export const HYDRANT_TYPES = {
  SOPRASUOLO: 'Soprasuolo',
  SOTTERRANEO: 'Sotterraneo',
  COLONNINA: 'Colonnina',
  ALTRO: 'Altro',
} as const;

export type HydrantType = (typeof HYDRANT_TYPES)[keyof typeof HYDRANT_TYPES];

export const HYDRANT_COLORS: Record<HydrantType, string> = {
  [HYDRANT_TYPES.SOPRASUOLO]: '#e74c3c',
  [HYDRANT_TYPES.SOTTERRANEO]: '#3498db',
  [HYDRANT_TYPES.COLONNINA]: '#f39c12',
  [HYDRANT_TYPES.ALTRO]: '#95a5a6',
};
